'use client';

import { Toaster } from '@goodneighbor/ui';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { APIProvider as MapsAPIProvider } from '@vis.gl/react-google-maps';
import { NextIntlClientProvider, useLocale } from 'next-intl';
import { I18nProvider } from 'react-aria-components';
import { NuqsAdapter } from 'nuqs/adapters/next/app';
import { useState } from 'react';
import en from '@goodneighbor/locale/messages/en';
import es from '@goodneighbor/locale/messages/es';
import { useLocaleStore } from '@/services/stores/locale';
import Script from 'next/script';

export default function Providers({ children }: { children: React.ReactNode }) {
  const { locale: localLocale } = useLocaleStore();
  const [queryClient] = useState(() => new QueryClient());
  const locale = useLocale();

  const resolvedLocale = localLocale || locale;

  return (
    <NextIntlClientProvider
      locale={resolvedLocale}
      messages={resolvedLocale === 'es' ? es : en}
    >
      <I18nProvider locale={resolvedLocale}>
        <QueryClientProvider client={queryClient}>
          <Toaster />
          <MapsAPIProvider
            apiKey={process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY || ''}
            libraries={['places']}
          >
            <NuqsAdapter>{children}</NuqsAdapter>
          </MapsAPIProvider>
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </I18nProvider>
      <Script
        src={`https://www.google.com/recaptcha/api.js?render=${process.env.NEXT_PUBLIC_CAPTCHA_SITE_KEY}`}
      />
    </NextIntlClientProvider>
  );
}
